const abtestApi = '/abtests';
export const fetchAbTestsSession = (sessionId: string) =>
  `${abtestApi}/session/${sessionId}`;
